import { LogIn } from 'lucide-react';
import { useAuth } from './AuthProvider.js';
import { SkeletonCard } from '../components/Skeleton.js';

export function AuthGate({ children }: { children: React.ReactNode }) {
  const auth = useAuth();

  // When OIDC is disabled (Tauri build, local dev without env) just render.
  if (!auth.enabled) return <>{children}</>;

  if (!auth.ready) {
    return (
      <div className="flex h-screen items-center justify-center p-8">
        <div className="max-w-sm space-y-3">
          <SkeletonCard />
          <SkeletonCard />
        </div>
      </div>
    );
  }

  if (!auth.user) {
    return (
      <div className="flex h-screen flex-col items-center justify-center bg-ink-950 px-6 text-center">
        <h1 className="text-[22px] font-semibold text-ink-100">remedy.build</h1>
        <p className="mt-2 max-w-[44ch] text-[13px] text-ink-400">
          Sign in to open, edit, and compile your Remedy folders. Authentication is handled by{' '}
          <code className="mono">auth.petitgen.com</code> (Zitadel, OIDC + PKCE).
        </p>
        <button
          onClick={auth.signin}
          className="mono mt-6 flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-[13px] font-medium text-ink-950 hover:bg-accent-400"
        >
          <LogIn size={15} /> Sign in
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
